import Logger from './Logger';

export default class ShareManager {
	constructor() {
		throw new Error('This is a static class');
	}

	static share() {
		if (navigator.share) {
			navigator.share({
				title: ShareManager.TITLE,
				text: ShareManager.DESCRIPTION,
				url: ShareManager.URL,
			})
				.then(() => Logger.log('Successful share'))
				.catch((error) => Logger.log('Error sharing', error));

			return true;
		}
		Logger.log('Web Share API not supported.');

		return false;
	}

	static ShareSupported() {
		return navigator.share;
	}

	static shareFacebook() {
		window.open(`https://www.facebook.com/sharer/sharer.php?u=${ShareManager.URL}`, '_blank');
	}

	static shareTwitter() {
		window.open(`https://x.com/intent/tweet?text=${encodeURI(ShareManager.DESCRIPTION)}&url=${ShareManager.URL}`, '_blank');
	}

	static shareEmail() {
		window.location.href = `mailto:?subject=${encodeURI(ShareManager.TITLE)}&body=${encodeURI(ShareManager.DESCRIPTION)}%20${ShareManager.URL}`;
	}

	static shareLinkedin() {
		window.open(`https://www.linkedin.com/shareArticle?mini=true&url=${ShareManager.URL}&title=${encodeURI(ShareManager.TITLE)}&summary=${encodeURI(ShareManager.DESCRIPTION)}`, '_blank');
	}

	static shareWhatsapp() {
		window.open(`https://wa.me/?text=${encodeURI(ShareManager.DESCRIPTION)}%20${ShareManager.URL}`, '_blank');
	}
}

ShareManager.TITLE = 'Stop Disasters!';
ShareManager.URL = 'https://www.stopdisastersgame.org';
ShareManager.DESCRIPTION = 'Stop Disasters! is a free-to-play disaster preparedness game developed by the United Nations Office for Disaster Risk Reduction (UNDRR).';
